/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useContext } from "react"; // React Stuff
import { BrowserView, MobileView } from "react-device-detect"; // Device Detection for two views
import withRouter from "../WithRouter";
// Common
import FadeIn from "../common/FadeIn";
import ReturnButton from "../common/ReturnButton";
//TimeRendering
import Moment from "react-moment";
// Import global business context
import { BusinessContextConsumer } from "../BusinessContext.js";
//Packages
import axios from "axios";
import { Container, Tabs, Tab, Col, Row, Form, Button } from "react-bootstrap";
import { isAuthenticatedTutor } from "./services/TutorAuth"; //import auth
import { Navigate, Link } from "react-router-dom";
//Subcomponents
import LoadingSpinner from "../LoadingSpinner";
import BlockIssueReports from "./page-parts/BlockIssueReports";

const TutorBlockInfoParent = (props) => {
  const [blockData, setBlockData] = useState({});
  const [viewMode, setViewMode] = useState("classinfo");
  // Extract the class ID
  const blockid = props.params.blockid;
  const prevBlockID = useRef(); //Reference the previous class ID to ensure new get request if it changes.
  // Get the class data and set it
  useEffect(async () => {
    prevBlockID.current = blockid; // Assign Refs Value to current load
    // Get the Class Data
    const blockDataRequest = await axios.get(`/api/tutor/manage/blocks/${blockid}`, {
      withCredentials: true,
    });
    return setBlockData(blockDataRequest.data);
  }, [blockid]); // Run useEffect when the classID changes to get new class data.

  return (
    <div className='ClassList' key={blockid}>
      <FadeIn delay={250} duration={450}>
        {isAuthenticatedTutor() ? (
          <Container>
            {blockData._id ? (
              <>
                <BrowserView>
                  <Tabs defaultActiveKey='classinfo' id='uncontrolled-tabs' className='text-center'>
                  <Tab eventKey='classinfo' title='Overview'>
                      <BlockInfo data={blockData} />
                    </Tab>
                    <Tab eventKey='progress' title='Progress &amp; Awards'>
                      <BlockIssueReports data={blockData} />
                    </Tab>
                    <Tab eventKey='register' title='Register'>
                      <BlockRegisterTab _id={blockData._id} />
                    </Tab>
                  </Tabs>
                </BrowserView>
                <MobileView>
                  <ModeSelect viewMode={viewMode} setViewMode={setViewMode} />
                  {viewMode === "classinfo" && (
                    <FadeIn delay={250} duration={450}>
                       <BlockInfo data={blockData} />
                    </FadeIn>
                  )}
                  {viewMode === "progress" && (
                    <FadeIn delay={250} duration={450}>
                      <BlockIssueReports data={blockData} />
                    </FadeIn>
                  )}
                  {viewMode === "register" && (
                    <FadeIn delay={250} duration={450}>
                       <BlockRegisterTab _id={blockData._id} />
                    </FadeIn>
                  )}
                </MobileView>
                <Row>
                  <Col className='text-center' sm='12'>
                    <ReturnButton />
                  </Col>
                </Row>
              </>
            ) : (
              <LoadingSpinner />
            )}
          </Container>
        ) : (
          <Navigate to='/tutor/' />
        )}
      </FadeIn>
    </div>
  );
};

const BlockInfo = (props) => {
  // Handle Context
  const BusinessContext = useContext(BusinessContextConsumer);
  const { currencySymbol } = BusinessContext;
  //Get the props.
  const blockInfo = props.data;

  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3'>
        <h1 className='mt-4'>Class Type: {blockInfo.LessonType}</h1>
        <p>
          <strong>Venue</strong>: {blockInfo.Venue.VenueName} at {blockInfo.Venue.VenueAddress}.{" "}
        </p>
        <p>
          <strong>Occupancy</strong>: {blockInfo.Subscribers_Number} / {blockInfo.MaxLearners}{" "}
        </p>
        <p>
          <strong>Description</strong>: {blockInfo.ShortDescription}
        </p>
        <p>
          <strong>Price</strong>: {currencySymbol + parseFloat(blockInfo.Price).toFixed(2)}
        </p>
        <p>
          <strong>Remaining Dates</strong>:{" "}
          {blockInfo.forwardDates.map((date, index) => (
            <span
              className='me-2 text-center shadow border p-1 mt-1 d-block d-md-inline-block'
              key={index}
            >
              <Moment format='ddd DD MMMM, h:mm A'>{date}</Moment>
            </span>
          ))}
        </p>
        <p>
          <strong>Dates</strong>:{" "}
          {blockInfo.Dates.map((date, index) => (
            <span
              className='me-2 text-center shadow border p-1 mt-1 d-block d-md-inline-block'
              key={index}
            >
              <Moment format='ddd DD MMMM, h:mm A'>{date}</Moment>
            </span>
          ))}
        </p>
      </Col>
    </Row>
  );
};



const BlockRegisterTab = (props) => {
  const blockID = props._id;
  return (
    <Row className='mt-5 mb-3 text-center'>
      <Col sm='12' className='border shadow p-3'>
        <h3 className='mt-4'>Registers</h3>
        <p>
          Registers for block classes are generated at block creation and persist for the lifecycle
          of the block. When your administrators changes dates, the dates on the register will automatically change
          to match your new dates.
        </p>
        <Row>
          <Col className='border'>
            <Button
              variant='success'
              className='mb-3 mt-3'
              type='link'
              size="lg"
              as={Link}
              to={`/tutor/block-registers/${blockID}`}
            >
              Go to Register
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const ModeSelect = (props) => {
  return (
    <Row>
      <Col>
        <Form className='mt-3 text-center'>
          <Form.Label>Choose Tab</Form.Label>
          <Form.Control
            as='select'
            value={props.viewMode}
            onChange={(e) => props.setViewMode(e.target.value)}
            custom
            className='border'
          >
            <option value='' disabled defaultValue>
              Select Option
            </option>
            <option value='classinfo'>Info</option>
            <option value='progress'>Progress &amp; Awards</option>
            <option value='register'>Registers</option>
          </Form.Control>
        </Form>
      </Col>
    </Row>
  );
};

export default withRouter(TutorBlockInfoParent);
